
import { defineComponent, PropType, computed } from 'vue'
import { STYLE_TYPE_LIST, STYLE_TYPE_OBJ } from '../../const'
import { styleType, sizeType } from '../../interface'
export default defineComponent({
  name: 'KButton',
  props: {
    // button接收的属性
    theme: {
      type: String as PropType<styleType>,
      default: STYLE_TYPE_OBJ.primary,
      validator: (val: string) => STYLE_TYPE_LIST.includes(val)
    },
    size: {
      type: String as PropType<sizeType>
    },
    icon: {
      type: String,
      default: ''
    },
    loading: Boolean,
    disabled: Boolean,
    round: Boolean,
    style: [String, Object],
    // 外框接的收属性
    buttonStyle: { type: String, default: '' },
    iscontainer: { type: Boolean }
  },
  emits: ['click'],
  setup(props, ctx) {
    const classes = computed(() => [
      `k-button--${props.theme}`,
      props.size ? `k-button--${props.size}` : '',
      {
        'is-disabled': props.disabled,
        'is-loading': props.loading,
        'is-round': props.round
      }
    ])
    const onClick = (e: TouchEvent | MouseEvent) => {
      ctx.emit('click', e)
    }
    return {
      classes,
      onClick
    }
  }
})
